import React, { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import './DeployNotice.css';

// Aviso de actualización de la app. Al recibir 'deploy:notice' muestra un
// banner con cuenta regresiva (no bloquea: da tiempo a terminar lo que se
// estaba haciendo). Al llegar a 0 —o si el backend se cae después del aviso—
// bloquea la pantalla, y cuando el backend vuelve recarga sola para tomar la
// versión nueva.
export default function DeployNotice() {
  const [phase, setPhase] = useState('idle'); // idle | countdown | blocked
  const [left, setLeft] = useState(60);
  const phaseRef = useRef('idle');
  useEffect(() => { phaseRef.current = phase; }, [phase]);

  useEffect(() => {
    const socket = io('/', { withCredentials: true });
    let timer = null;

    socket.on('deploy:notice', ({ seconds = 60 } = {}) => {
      clearInterval(timer);
      setLeft(seconds);
      setPhase('countdown');
      timer = setInterval(() => {
        setLeft(prev => {
          if (prev <= 1) { clearInterval(timer); setPhase('blocked'); return 0; }
          return prev - 1;
        });
      }, 1000);
    });

    socket.on('disconnect', () => {
      // Solo bloquea si hubo aviso previo: una microcaída del socket sin
      // deploy anunciado no tiene que asustar a nadie.
      if (phaseRef.current !== 'idle') { clearInterval(timer); setPhase('blocked'); }
    });

    socket.on('connect', () => {
      if (phaseRef.current === 'blocked') {
        // El backend volvió: recargar para levantar el frontend nuevo.
        setTimeout(() => window.location.reload(), 1500);
      }
    });

    return () => { clearInterval(timer); socket.close(); };
  }, []);

  if (phase === 'idle') return null;

  if (phase === 'countdown') {
    return (
      <div className="dn-banner" role="alert">
        <span className="dn-banner-num">{left}</span>
        <span>
          <b>La app se actualiza en {left} segundo{left === 1 ? '' : 's'}.</b>
          {' '}Guardá lo que estés haciendo — queda bloqueada un momento.
        </span>
      </div>
    );
  }

  return (
    <div className="dn-overlay">
      <div className="dn-spin" />
      <h2>Actualizando la app…</h2>
      <p>Vuelve sola en un momento. No cierres la pestaña.</p>
    </div>
  );
}
